import { registerApplication, start } from 'single-spa';

registerApplication(
  'root',
  () => import('./root.app'),
  () => true,
);

start();
